export default __webpack_public_path__ + "static/media/face.264e9d99.svg";